/**
 * Normalize REACT_APP_BACKEND_URL for axios (trim, fix common typos, no trailing slash).
 * Axios baseURL is `${API_BASE}/api` — avoid double slashes or malformed scheme.
 */
export function normalizeBackendUrl(url) {
  if (url == null) return '';
  let u = String(url).trim();
  if (u === '') return '';
  u = u.replace(/^hhtps:\/\//i, 'https://');
  u = u.replace(/^htttps:\/\//i, 'https://');
  u = u.replace(/\/+$/, '');
  return u;
}

/** Default API origin when env is missing (document root must be backend `public/`). */
export const DEFAULT_API_BASE = 'https://smdapi.navyaclothingo.com/public';
